


































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import ItemPO from "../../../store/entities/basedata/itemspo";
@Component
export default class EditItem extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  item: ItemPO = new ItemPO();
  created() { }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "items/update",
          data: this.item,
        });
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.item = Util.extend(true, {}, this.$store.state.items.editItems);
    }
  }
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    enCode: [
      {
        required: true,
        message: this.L("Encode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
}
